import React from 'react';
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import MaterialTable from 'material-table';
import { accountsSyncStatusTableOption } from '../../helper/constants';
import Helper from '../../helper/helper';

const AccountStatus = (props) => {

    const acc = props.acc;

    return (
        <div className='accounts-background'>
            <MaterialTable
                data={[acc]}
                options={accountsSyncStatusTableOption}
                components={{
                    Header: () => {
                        return <div className='accounts-background'>
                            <TableRow>
                                <TableCell align='left' width="40rem">{acc.name}</TableCell>
                                <TableCell align='left' width="30%">{Helper.parseDate(acc.lastUpdateDate)}</TableCell>
                                <TableCell align='left' width="10%">{acc.isHealthy ? "Healthy" : "Unhealthy"}</TableCell>
                                <TableCell align='left' width="10%">
                                    {acc.isHealthy ? <i className="fas fa-check circle-color-healthy" /> : <i className="fas fa-minus circle-color-unhealthy"/>}
                                </TableCell>
                            </TableRow>
                        </div>
                    }
                }}>
            </MaterialTable>
        </div>
    );
};

export default AccountStatus;